module.exports = __webpack_public_path__ + "img/xslogo.2bcf2d4f.png";